import React, { Component } from "react";
import {
  Spin,
  message,
  Radio,
  Space,
} from "antd";
import Bridge from "../../../utils/Bridge";
import { speech_consent_form_content,speech_demographics_form_type } from "../../../utils/consts";
import { logEvent } from "../../../utils/analytics";

export default class ConsentFormChild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      is_consent_form_signed:false,
      participation_attestation:"",
      neurostamp_id:"",
      modality_id:"",
      email:"",
      are_you_18_or_older:"",
      currently_live_in_us:"",
      user_is:"",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.allergies_and_presriptions;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
       
        if (response.status == "1") {
          if(response.is_consent_form_signed==true){
            window.location.assign('/basic-details')
            return
          }
          this.setState({
            neurostamp_id: response.neurostamp_id,
            email: response.email,
            modality_id:response.modality_id
          })
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save_details = () => {
    if (!this.state.are_you_18_or_older) {
      message.warning("Please choose one option from 'Are you 18 or older?' field");
      return;
    }
    if (!this.state.currently_live_in_us) {
      message.warning("Please choose one option from 'Do you currently live in the United States?' field");
      return;
    }
    if (!this.state.user_is) {
      message.warning("Please choose one option from 'This user is a...' field");
      return;
    }
    if (!this.state.is_consent_form_signed) {
      message.warning("Please choose one option");
      return;
    }
    if (this.state.is_consent_form_signed==1) {
      if (!this.state.participation_attestation) {
        message.warning("Please enter participation attestation");
        return;
      }
    }
    if (this.state.is_consent_form_signed==1) {
      
      let questions = [
        {
          form: "WELCOME",
          view_name: "v_EALSPE_ICFALS_nt",
          field: "STDPART",
          value:this.state.is_consent_form_signed,
        },
        {
          form: "WELCOME",
          view_name: "v_EALSPE_ICFALS_nt",
          field: "ATTEST",
          value:this.state.participation_attestation,
        },
        {
          form: "Are you 18 or older?",
          view_name: "v_EALSPE_ICFALS_nt_18_YEAR_OR_OLDER",
          field: "ARE_YOU_18_OR_OLDER",
          value:this.state.are_you_18_or_older,
        },
        {
          form: "Do you currently live in the United States?",
          view_name: "v_EALSPE_ICFALS_nt_LIVE_IN_UNITED_STATES",
          field: "LIVE_IN_UNITED_STATES",
          value:this.state.currently_live_in_us,
        },
      ];
      let present_non_als=false;
      if(this.state.user_is==2){
        let obj={
          form: "Non-ALS Users",
          view_name: "v_EALSPE_NALSUSR",
          field: "NALSTYP",
          value:"",
        }
        questions.push(obj)
        present_non_als=true
      }
      if(this.state.user_is==1){
        let obj={
          form: "ALS Users",
          view_name: "v_EALSPE_NALSUSR_ALS_USER",
          field: "NALSTYP_ALS",
          value:1,
        }
        questions.push(obj)
      }
      let params = {
        data: JSON.stringify(questions),
        step: speech_demographics_form_type.consent_form,
        email:this.state.email,
        neurostamp_id:this.state.neurostamp_id,
        participants_accounts_id:localStorage.getItem("ap_participants_accounts_id"),
        modality_id:this.state.modality_id
      };
      this.setState({ loading: true });
      Bridge.demographics.speech
        .save(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.data.status == "1") {
            logEvent("consent_form_submitted");
            message.success(response.data.message);
            this.setState(
              {
                loading: false,
              },
              () => {
                // window.location.assign('/dashboard')
                if(present_non_als==true){
                  this.props.set_active_step(1);
                  this.props.set_non_als_user(present_non_als)
                }else {
                  this.props.set_active_step(8);
                  this.props.set_non_als_user(present_non_als)
                }
              }
            );
          } else {
            message.error(response.data.message);
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          message.warning("Please try again!!", error);
          this.setState({ loading: false });
        });
    }else{
      message.success('Thank you for showing your interest', 3)
      setTimeout(()=>{
        this.logout();
      },2000)
    }
  };
  logout = () => {
    localStorage.clear();
    window.location.assign("/");
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>CONSENT FORM</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="consent-form-content">
              <h4 class="mb-4 pl-3 font-weight-bold">WELCOME</h4>
              {speech_consent_form_content.map((item,index)=>{
                return (
                  <p key={index}>{item}</p>
                )
              })}
              <div className="form-group">
                <p className="input-heading">Are you 18 or older?</p>
                <Radio.Group
                  onChange={(e) => this.setState({ are_you_18_or_older: e.target.value })}
                  value={this.state.are_you_18_or_older}
                  direction="horizontal"
                >
                  <Space>
                    <Radio value={'1'}>Yes</Radio>
                    <Radio value={'2'}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <p className="input-heading">Do you currently live in the United States?</p>
                <Radio.Group
                  onChange={(e) => this.setState({ currently_live_in_us: e.target.value })}
                  value={this.state.currently_live_in_us}
                  direction="horizontal"
                >
                  <Space>
                    <Radio value={'1'}>Yes</Radio>
                    <Radio value={'2'}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <p className="input-heading">This user is a...</p>
                <Radio.Group
                  onChange={(e) => this.setState({ user_is: e.target.value })}
                  value={this.state.user_is}
                  direction="horizontal"
                >
                  <Space>
                    <Radio value={'1'}>I Have ALS/MND</Radio>
                    <Radio value={'2'}>No ALS/MND</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <p className="input-heading">If you have no questions and agree to proceed, please select "YES"</p>
                <Radio.Group
                  onChange={(e) => this.setState({ is_consent_form_signed: e.target.value,participation_attestation:"" })}
                  value={this.state.is_consent_form_signed}
                  direction="vertical"
                >
                  <Space>
                    <Radio value={'1'}>Yes</Radio>
                    <Radio value={'2'}>No</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="participation_attestation"
                  placeholder="Participation Attestation (Initials)"
                  disabled={this.state.is_consent_form_signed == 1?false:true}
                  value={this.state.participation_attestation}
                  onChange={(e) => {
                    this.setState({
                      participation_attestation: e.target.value,
                    });
                  }}
                  style={{ width: "100%", height: 55, maxWidth: 500 }}
                />
              </div>
            </div>
            <button
              className="submit-button"
              style={{ padding: "9px 15px 10px 20px" }}
              onClick={() => this.save_details()}
            >
              <box-icon
                name="save"
                type="solid"
                color="#fff"
                size={'17px'}
                style={{ position: 'relative', top: -1, left: -11 }}
              ></box-icon>
              Save{" "}
            </button>
          </div>
        </Spin>
      </div>
    );
  }
}
